export default function BackToTop() {
  return (
    <div className="text-center back-to-top">
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="to-top-button"
      >
        Back to top
      </button>
    </div>
  );
}